import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {RangeFilterItem} from '../../../interface/range-filter-item'
import {ActivatedRoute} from '@angular/router';
import {UntilDestroy} from '@ngneat/until-destroy';
import {BrowserAPIService} from "@bloomscorp/ngbase";

@UntilDestroy()
@Component({
	selector: 'fb-double-range-slider',
	templateUrl: './double-range-slider.component.html',
	styleUrls: ['./double-range-slider.component.scss']
})
export class DoubleRangeSliderComponent implements OnInit, AfterViewInit {

	@Input() public rangeInput: RangeFilterItem = {} as RangeFilterItem;

	@Output() minMaxRange: EventEmitter<{ min: number, max: number }> = new EventEmitter<{ min: number, max: number }>();
	@ViewChild('min') min: ElementRef<HTMLInputElement> | undefined;
	@ViewChild('max') max: ElementRef<HTMLInputElement> | undefined;


	public value: number = 10;
	public highValue: number = 60;
	restComponent = true;

	public isBrowser: boolean = false;

	constructor(
		private _cd: ChangeDetectorRef,
		private _activeRoute: ActivatedRoute,
		private _browser: BrowserAPIService
	) {
		this.isBrowser = _browser.isBrowser();
	}

	public ngOnInit(): void {

		// this._activeRoute.queryParams.subscribe(params => {

		// 	if (Object.keys(params).length === 0) this.reset();
		// });
	}


	public triggerSlider(min: number, max: number) {
		if (!max) return
		this.min ? this.min.nativeElement.value = min + '' : 0 + '';
		this.max ? this.max.nativeElement.value = max + '' : 0 + '';

		this.valueChangedMin();
		this.valueChangedMax();
	}

	public valueChangedMin(): void {
		if (this.min && this.max) {
			this.minMaxRange.emit({
				min: parseInt(this.min.nativeElement.value),
				max: parseInt(this.max.nativeElement.value)
			})

			this.rangeInput.minGap = this.rangeInput.minGap || 1;
			if ((+this.max.nativeElement.value - +this.min.nativeElement.value) <= this.rangeInput.minGap) {
				this.min.nativeElement.value = (+this.max.nativeElement.value - this.rangeInput.minGap) + '';
				this.value = (+this.max.nativeElement.value - this.rangeInput.minGap);
			}

		}
	}


	public valueChangedMax(): void {

		if (this.min && this.max) {
			this.minMaxRange.emit({
				min: +this.min.nativeElement.value,
				max: +this.max.nativeElement.value
			})

			this.rangeInput.minGap = this.rangeInput.minGap || 1;
			if ((+this.max.nativeElement.value - +this.min.nativeElement.value) <= this.rangeInput.minGap) {
				this.max.nativeElement.value = (+this.min.nativeElement.value + this.rangeInput.minGap) + '';
				this.highValue = (+this.min.nativeElement.value + this.rangeInput.minGap);
			}
		}

	}

	public minValueInput(evt: any): void {
		let data = evt.target.value;
		this.rangeInput.value1 = +data
		this.valueChangedMin();
		this.valueChangedMax();
	}

	public highValueInput(evt: any): void {
		let copyMaxData = evt.target.value;
		let data = evt.target.value;
		if (+data != 0) {
			this.rangeInput.value2 = +data
			this.valueChangedMin();
			this.valueChangedMax();
		} else {
			this.rangeInput.max = +copyMaxData;
		}
	}

	public reset(): void {
		this.rangeInput.min = 0;
		this.rangeInput.max = this.rangeInput.defaultMax;

		this.rangeInput.value1 = 0;
		this.rangeInput.value2 = this.rangeInput.defaultMax;


		if (this.min) this.min.nativeElement.value = '0';
		if (this.max) this.max.nativeElement.value = this.rangeInput.defaultMax + '';
		this.minMaxRange.emit({
			min: 0,
			max: this.rangeInput.defaultMax
		});

		this.triggerSlider(0, this.rangeInput.defaultMax)
		this.restComponent = false;
		setTimeout(() => this.restComponent = true, 10)
	}

	public ngAfterViewInit(): void {
		this._cd.detectChanges();
	}


}
